import types from '../constants'
import { findIndexByKeyValue } from './util'

const initialState = {
  playlists: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  children: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  banners: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  resumeVideo: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  recommendationUser: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
}

export default function home(state = initialState, action) {
  switch (action.type) {
    case types.GET_HOME_PLAYLIST_LOADING:
      return { ...state, playlists: { ...action.payload } }
    case types.GET_HOME_PLAYLIST_SUCCESS:
      return { ...state, playlists: { ...action.payload } }
    case types.GET_HOME_PLAYLIST_ERROR:
      return { ...state, playlists: { ...action.payload } }
    case types.GET_HOME_BANNER_LOADING:
      return { ...state, banners: { ...action.payload } }
    case types.GET_HOME_BANNER_SUCCESS:
      return { ...state, banners: { ...action.payload } }
    case types.GET_HOME_BANNER_ERROR:
      return { ...state, banners: { ...action.payload } }
    case types.GET_HOME_RESUME_VIDEO_LOADING:
      return { ...state, resumeVideo: { ...action.payload } }
    case types.GET_HOME_RESUME_VIDEO_SUCCESS:
      return { ...state, resumeVideo: { ...action.payload } }
    case types.GET_HOME_RESUME_VIDEO_ERROR:
      return { ...state, resumeVideo: { ...action.payload } }
    case types.GET_RECOMMENDATION_USER_LOADING:
      return { ...state, recommendationUser: { ...action.payload } }
    case types.GET_RECOMMENDATION_USER_SUCCESS:
      return { ...state, recommendationUser: { ...action.payload } }
    case types.GET_RECOMMENDATION_USER_ERROR:
      return { ...state, recommendationUser: { ...action.payload } }

    case types.GET_HOME_PL_LOADING:
      return { ...state, playlists: { ...action.payload.playlists } }
    case types.GET_HOME_PL_SUCCESS:
      return { ...state, playlists: { ...action.payload.playlists }, children: { ...action.payload.children } }
    case types.GET_HOME_PL_ERROR:
      return { ...state, playlists: { ...action.payload.playlists } }

    case types.HOME_VIDEO_REMINDERS_LOADING:
      let currentChildren_loading = [...state.children.data]
      currentChildren_loading.map(child => {
        if (child.meta.id === action.payload.playlistId) {
          child.reminders = {
            meta: action.payload.reminders.meta,
            data: action.payload.reminders.data,
          }
        }
      })
      return {
        ...state,
        children: {
          ...state.children,
          data: [...currentChildren_loading],
        },
      }
    case types.HOME_VIDEO_REMINDERS:
      let currentChildren = [...state.children.data]
      currentChildren.map(child => {
        if (child.meta.id === action.payload.playlistId) {
          child.reminders = {
            meta: action.payload.reminders.meta,
            data: action.payload.reminders.data,
          }
        }
      })
      return {
        ...state,
        children: {
          ...state.children,
          data: [...currentChildren],
        },
      }
    default:
      return {
        ...initialState,
        ...state,
      }
  }
}
